// Typographic COPPER & VINE wordmark. Copper appears ONLY on the ampersand.
// stacked=true for large editorial lockup, false for compact header lockup.
export function Wordmark({ stacked = false, className = "", tone = "ink" }) {
  const ink = tone === "bone" ? "#F6F2EC" : "#1F1B16";
  if (stacked) {
    return (
      <span
        className={`cv-sans inline-flex flex-col leading-none ${className}`}
        style={{ color: ink }}
        aria-label="Copper and Vine"
      >
        <span
          className="cv-hairline"
          style={{ background: ink, opacity: 0.85, marginBottom: "0.5rem" }}
        />
        <span
          style={{
            fontWeight: 300,
            letterSpacing: "0.18em",
            fontSize: "clamp(1.6rem, 5vw, 2.4rem)",
          }}
        >
          COPPER
        </span>
        <span
          style={{
            fontWeight: 300,
            letterSpacing: "0.18em",
            fontSize: "clamp(1.6rem, 5vw, 2.4rem)",
          }}
        >
          <span
            className="cv-serif"
            style={{ color: "#A6633C", fontWeight: 500, fontStyle: "italic" }}
          >
            &amp;
          </span>{" "}
          VINE
        </span>
      </span>
    );
  }
  return (
    <span
      className={`cv-sans inline-flex items-baseline ${className}`}
      style={{
        color: ink,
        fontWeight: 300,
        letterSpacing: "0.2em",
        fontSize: "0.95rem",
        whiteSpace: "nowrap",
      }}
      aria-label="Copper and Vine"
    >
      COPPER&nbsp;
      <span
        className="cv-serif"
        style={{ color: "#A6633C", fontWeight: 500, fontStyle: "italic", fontSize: "1.05rem" }}
      >
        &amp;
      </span>
      &nbsp;VINE
    </span>
  );
}
